// extracted by mini-css-extract-plugin
module.exports = {"link":"BookPropertyButton-module--link--3efJo","arrow":"BookPropertyButton-module--arrow--23afa"};